import * as tslib_1 from "tslib";
import { API } from 'aws-amplify';
import { anonymize } from './anonymizer.util';
function wrapApiMethod(original, demoModeService, viewAsScopeService) {
    var _this = this;
    return function (apiName, path, init) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var response, userAttr, isSuperAdmin, queryParams, breakdownBy;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, original.call(API, apiName, path, init)];
                case 1:
                    response = _a.sent();
                    userAttr = viewAsScopeService.getOriginalUserAttributes();
                    isSuperAdmin = userAttr && userAttr['custom:role'] === 'sadmin';
                    if (demoModeService.isDemoMode() && isSuperAdmin && response != null) {
                        queryParams = (init && typeof init === 'object' && init.queryStringParameters);
                        breakdownBy = queryParams && queryParams.breakdownBy;
                        if (!breakdownBy && typeof path === 'string') {
                            // Drink breakdown API: labels are drink names, don't anonymize
                            if (path.includes('drink-volume-breakdown') && !path.includes('drink-volume-machine-breakdown')) {
                                breakdownBy = 'drink';
                            }
                            // Machine drink volume APIs delete breakdownBy but labels are always machine IDs
                            else if (path.includes('drink-volume-by-machine') || path.includes('drink-volume-machine-breakdown')) {
                                breakdownBy = 'machine';
                            }
                        }
                        return [2 /*return*/, anonymize(response, { breakdownBy: breakdownBy })];
                    }
                    return [2 /*return*/, response];
            }
        });
    }); };
}
/**
 * Patches the Amplify API to anonymize responses when demo mode is enabled.
 * Only applies anonymization for super admins.
 * Must be called after Amplify.configure() in app initialization.
 */
export function patchAmplifyApiForDemoMode(demoModeService, viewAsScopeService) {
    var originalGet = API.get.bind(API);
    var originalPost = API.post.bind(API);
    var originalPut = API.put.bind(API);
    var originalDel = API.del.bind(API);
    API.get = wrapApiMethod(originalGet, demoModeService, viewAsScopeService);
    API.post = wrapApiMethod(originalPost, demoModeService, viewAsScopeService);
    API.put = wrapApiMethod(originalPut, demoModeService, viewAsScopeService);
    API.del = wrapApiMethod(originalDel, demoModeService, viewAsScopeService);
}
